import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getColor } from "utils/colors";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        tipoResiduo: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.tipoResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcionResiduo: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.descripcionResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        cantidadResiduo: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.cantidadResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        unidadResiduo: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.unidadResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        observacion: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.observacion || "Sin observación"}
            </SoftTypography>
          </SoftBox>
        ),
        descripcionTratamiento: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.descripcionTratamiento || "Sin descripción"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidadTratamiento: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.cantidadTratamiento || "0"}
            </SoftTypography>
          </SoftBox>
        ),
        vehiculo: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.vehiculo || "-"}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "tipoResiduo", desc: "Tipo de Residuo", align: "center", noOrder: true, width: "1%" },
  { name: "descripcionResiduo", desc: "Descripción del Residuo", align: "left", noOrder: true },
  { name: "cantidadResiduo", desc: "Cantidad", align: "left", noOrder: true },
  { name: "unidadResiduo", desc: "Unidad", align: "left", noOrder: true },
  { name: "observacion", desc: "Observación", align: "left", noOrder: true },
  { name: "descripcionTratamiento", desc: "Disposición", align: "left", noOrder: true },
  { name: "cantidadTratamiento", desc: "Cantidad Dispuesta", align: "left", noOrder: true },
  { name: "vehiculo", desc: "Transportista y Operador", align: "left", noOrder: true },
];

export default { columns, getRows };
